<template>
  <div class="hyperlink-container">
    <b-button
      icon-left="link-variant"
      variant="primary"
      @click="openSelectHyperlink"
      >{{ $t('create_external_link') }}</b-button
    >
    <b-tag
      type="is-primary"
      rounded
      v-if="files.length > 0 && !singleSelectMode"
    >
      {{ files.length }}
    </b-tag>

    <DocumentsModal
      v-if="isDocumentModalVisible"
      :isDocumentModalVisible="isDocumentModalVisible"
      @close="closeDocumentModal"
      :selectMode="true"
      :singleSelectMode="singleSelectMode"
      @onSelectMultipleFiles="onSelectMultipleFiles"
      :preSelectedFiles="preSelectedFiles"
    />
  </div>
</template>
<script>
import DocumentsModal from '../DocumentsModal';

export default {
  name: 'HyperlinkButton',
  components: {
    DocumentsModal,
  },

  props: {
    instruction: {
      type: Object,
      required: true,
    },
    singleSelectMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isDocumentModalVisible: false,
      files: [],
    };
  },

  computed: {
    preSelectedFiles() {
      return this.files.map((f) => (f._id ? f._id : f));
    },
  },

  mounted() {
    this.files = this.instruction?.linkedInternalDocuments || [];
  },

  methods: {
    openSelectHyperlink() {
      this.isDocumentModalVisible = true;
    },
    closeDocumentModal() {
      this.isDocumentModalVisible = false;
    },
    onSelectMultipleFiles(files) {
      this.closeDocumentModal();
      const fileIds = files.map((entry) => entry._id);
      this.files = files;
      if (this.singleSelectMode) {
        this.$emit('singleFile', files[0]);
      }
      this.$emit('onLinkedInternalDocuments', fileIds);
    },
  },
};
</script>
<style scoped>
.hyperlink-container {
  margin-top: 10px;
}

.tag {
  position: relative;
  top: -10px;
  left: -10px;
}
</style>
